import * as constants from 'common/constants';
// import { field } from 'api';

export const toggleFieldView = payload => ({
  type: constants.FIELD_DISPLAY_TOGGLE,
  payload,
});

// return a sorted fields list with added fields crops (sorted array) and plantedArea
// function addCropsToFields(fields, crops) {
//   const indexedFields = {};

//   // transform to Acres and also ensure number type
//   function toAcres(area, type) {
//     const HECTARES_TO_ACRES = 2.47105;
//     if (type === 'hectares') {
//       return area * HECTARES_TO_ACRES;
//     }
//     return area * 1;
//   }

//   fields.forEach(field => {
//     if (field && field.name) {
//       // we have sane field data
//       // add crops and planted area attributes
//       field.crops = [];
//       field.plantedArea = 0;
//       indexedFields[field.name] = field;
//     }
//   });

//   crops.forEach(fieldCrop => {
//     const field = indexedFields[fieldCrop.fieldName];
//     if (field) {
//       field.crops.push(fieldCrop);
//       // acres or hectares
//       field.plantedArea += toAcres(fieldCrop.plantedArea.size, fieldCrop.plantedArea.type);
//     }
//   });

//   // sort the fields in descending order of plantedArea
//   fields.sort((field1, field2) => field1.plantedArea < field2.plantedArea);

//   // sort the crops list for each fields
//   fields.forEach(field => field.crops.sort((crop1, crop2) =>
//     toAcres(crop1.plantedArea.size, crop1.plantedArea.type) < toAcres(crop2.plantedArea.size, crop2.plantedArea.type)));

//   return fields;
// }

// export const fetchFieldsList = (season) => async (dispatch) => {
//   field.getAllFields(season).then(res => res.json())
//     .then(res => {
//       // data is null for each individual failed field query, filter out null fields
//       const fields = (res.data && res.data.getAllFields || []).filter(field => field);
//       const crops = res.data && res.data.getAllCropsForField || [];

//       dispatch({ type: constants.FIELD_LIST_SUCCESS, payload: {fields: addCropsToFields(fields, crops)}});
//     })
//     .catch(() => {
//       // TODO: Handle err
//       //console.error('Error fetching field:', error.message);
//     });
// };

// export const createField = (fieldCreateInput) => async (dispatch) => {
//   field.createField(fieldCreateInput).then(res => res.json())
//     .then(res => {
//       // TODO: look for res.error
//       dispatch({ type: constants.FIELD_CREATE_SUCCESS, payload: { field: res } });
//     })
//     .catch((error) => {
//       dispatch({ type: constants.FIELD_CREATE_ERROR, payload: { error }});
//     });
// };

// export const removeLocalField = ({season, title}) => async (dispatch) => {
//   dispatch({
//     type: constants.REMOVE_LOCAL_FIELD,
//     payload: {season, title}
//   });
// };



// WEBPACK FOOTER //
// ./src/actions/field.js